import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DpModuleService } from '../../../dp-module/dp-module.service';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-declarationoftradepopup',
  templateUrl: './declarationoftradepopup.component.html',
  styleUrls: ['./declarationoftradepopup.component.scss']
})
export class DeclarationoftradepopupComponent implements OnInit {
  @Input() name;
  @Input() listDpDetails;
  accessUser: any;
  dotstatusCreateForm:FormGroup;
  dotstatusOldCreateForm:FormGroup;
  dpNameDetails: string;
  isLoading = false;
  button = 'Update';
  prequityshares: boolean = false;
  prpreferenceshares: boolean = false;
  prwarrantsshares: boolean = false;
  prconvertibledebenturesshares: boolean = false;
  prnonconvertibledebentureshares: boolean = false;
  prrightsentitlementsshares: boolean = false;
  prothersshares: boolean = false;
  currentYear: number;
  companyName: string | null;
  dpPersonName: any;
    @ViewChild('delclarationcontent') delclarationcontent!: ElementRef;
  equitysharesValue: any;
  preferencesharesValue: any;
  warrantssharesValue: any;
  convertiblesharesValue: any;
  nonconvertiblesharesValue: any;
  rightentitlesharesValue: any;
  otherssharesValue: any;
  checkboxgroupArr: any;
  OldcheckboxgroupArr: any;
  checkValidation:any;
  submitted: boolean = false;
  
   constructor(private modalService: NgbModal, public activeModal: NgbActiveModal, private dpService:DpModuleService, private router:Router, 
    private fb: FormBuilder, private toastr: ToastrService ) {
        this.accessUser = sessionStorage.getItem('access_user');
       }
  ngOnInit(): void {
    let accessData:any = sessionStorage.getItem('model_access_controller');    
    let accessModelController = JSON.parse(accessData);
    if(accessModelController.typeofcompanyshares_access.equityshares == true || accessModelController.typeofcompanyshares_access.equityshares == 1){
       this.prequityshares = true;
    }
    if(accessModelController.typeofcompanyshares_access.preferenceshares == true || accessModelController.typeofcompanyshares_access.preferenceshares == 1){
       this.prpreferenceshares = true;
    }
    if(accessModelController.typeofcompanyshares_access.warrantsshares == true || accessModelController.typeofcompanyshares_access.warrantsshares == 1){
       this.prwarrantsshares = true;
    }
    if(accessModelController.typeofcompanyshares_access.convertibledebenturesshares == true || accessModelController.typeofcompanyshares_access.convertibledebenturesshares == 1){
       this.prconvertibledebenturesshares = true;
    }
    if(accessModelController.typeofcompanyshares_access.nonconvertibledebentureshares == true || accessModelController.typeofcompanyshares_access.nonconvertibledebentureshares == 1){
       this.prnonconvertibledebentureshares = true;
    }
    if(accessModelController.typeofcompanyshares_access.rightsentitlementsshares == true || accessModelController.typeofcompanyshares_access.rightsentitlementsshares == 1){
       this.prrightsentitlementsshares = true;
    }
    if(accessModelController.typeofcompanyshares_access.othersshares == true || accessModelController.typeofcompanyshares_access.othersshares == 1){
       this.prothersshares = true;
    }
   
    this.dotstatusCreateForm = this.fb.group({  
      
      checkboxgroup : this.fb.group({
        equityshares : new FormControl('', [Validators.required,Validators.pattern("^[0-9]*$")]),  
        preferenceshares : new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]),  
        warrantsshares : new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]),  
        convertibledebenturesshares : new FormControl('', [Validators.required,Validators.pattern("^[0-9]*$")]),  
        nonconvertibledebenturesshares : new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]),  
        rightsentitlementsshares : new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]),  
        othersshares : new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]), 
        //declaration: new FormControl(''),
        // checkbox: [false],
        // checkbox1: [false]
      })
    });
    this.dotstatusOldCreateForm = this.fb.group({  
      
      checkboxgroup : this.fb.group({
        equityshares : new FormControl('', [Validators.required,Validators.pattern("^[0-9]*$")]),  
        preferenceshares : new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]),  
        warrantsshares : new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]),  
        convertibledebenturesshares : new FormControl('', [Validators.required,Validators.pattern("^[0-9]*$")]),  
        nonconvertibledebenturesshares : new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]),  
        rightsentitlementsshares : new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]),  
        othersshares : new FormControl('',[Validators.required,Validators.pattern("^[0-9]*$")]), 
        //declaration: new FormControl(''),
        // checkbox: [false],
        // checkbox1: [false]
      })
    });
    this.currentYear=new Date().getFullYear();
    this.companyName = sessionStorage.getItem('companyName');
    this.dpPersonName = this.listDpDetails.dpName;
    this.declarationsharescount(this.listDpDetails);
  
     //this.dpNameDetails = parsedArray[0]?.declaration; 

   

    // if(this.listDpDetails.checkboxgroup == '' || this.listDpDetails.checkboxgroup == null){
    //   this.dpNameDetails = "I "+ this.dpPersonName +", hereby confirm that as of April 1, " + this.currentYear + ", I hold [insert number of shares] shares of " + this.companyName + " (hereinafter referred to as the Company), in compliance with the Securities and Exchange Board of India (Prohibition of Insider Trading) Regulations, 2015, the Companys Code of Conduct, and its policies."

    // }else{
        // let declarationArr:any =[];
        // let declaration = JSON.parse(this.listDpDetails.checkboxgroup);
        // const add = this.dotstatusCreateForm.get('checkboxgroup') as FormGroup;        
        // declarationArr.push(declaration);
        // const parsedArray = declarationArr.map(item => JSON.parse(item));
        //  this.dpNameDetails = parsedArray[0]?.declaration; 
        // add?.patchValue(parsedArray[0]);
      
      
    //}
   
    
  }
  get equityshares() {
    return this.dotstatusCreateForm.get('checkboxgroup.equityshares');
  }
  get preferenceshares() {
    return this.dotstatusCreateForm.get('checkboxgroup.preferenceshares');
  }
  get warrantsshares() {
    return this.dotstatusCreateForm.get('checkboxgroup.warrantsshares');
  }
  get convertibledebenturesshares() {
    return this.dotstatusCreateForm.get('checkboxgroup.convertibledebenturesshares');
  }
  get nonconvertibledebenturesshares() {
    return this.dotstatusCreateForm.get('checkboxgroup.nonconvertibledebenturesshares');
  }
  get rightsentitlementsshares() {
    return this.dotstatusCreateForm.get('checkboxgroup.rightsentitlementsshares');
  }
  get othersshares() {
    return this.dotstatusCreateForm.get('checkboxgroup.othersshares');
  }
  declarationsharescount(dpDataArr){
    let declarationArr:any =[];
    this.checkboxgroupArr =[];
    let parsedArray:any = [];
    let declaration = JSON.parse(dpDataArr.checkboxgroup);
    this.checkboxgroupArr = this.dotstatusCreateForm.get('checkboxgroup') as FormGroup;        
    this.OldcheckboxgroupArr = this.dotstatusOldCreateForm.get('checkboxgroup') as FormGroup;        
    if(declarationArr == null || declarationArr == ''){
      declarationArr.push(this.checkboxgroupArr.value);
       parsedArray = declarationArr;

    }else{
      declarationArr.push(declaration);
       parsedArray = declarationArr?.map(item => JSON.parse(item));
    }
    let itemList = {'dpid' : dpDataArr.id,'dpname': this.dpPersonName, 'companyname': this.companyName}
    this.dpService.dpsharescountlist(itemList).subscribe(result =>{
        let dpshareslist = result['data'];

        if(dpshareslist.length > 0){
            parsedArray[0]['equityshares'] = dpshareslist[0].equityshares
            parsedArray[0]['preferenceshares'] = dpshareslist[0].preferenceshares
            parsedArray[0]['warrantsshares'] = dpshareslist[0].warrantsshares
            parsedArray[0]['convertibledebenturesshares'] = dpshareslist[0].convertibleshares
            parsedArray[0]['nonconvertibledebenturesshares'] = dpshareslist[0].nonconvertibleshares
            parsedArray[0]['rightsentitlementsshares'] = dpshareslist[0].rightentitleshares
            parsedArray[0]['othersshares'] = dpshareslist[0].othersshares
        }else{
          parsedArray[0]['equityshares'] = '';
            parsedArray[0]['preferenceshares'] = '';
            parsedArray[0]['warrantsshares'] = '';
            parsedArray[0]['convertibledebenturesshares'] = '';
            parsedArray[0]['nonconvertibledebenturesshares'] = '';
            parsedArray[0]['rightsentitlementsshares'] = '';
            parsedArray[0]['othersshares'] = '';
        }
        this.checkboxgroupArr?.patchValue(parsedArray[0]);
        this.OldcheckboxgroupArr?.patchValue(parsedArray[0]);
        this.dotstatusCreateForm.statusChanges.subscribe(status => {
         const isEqual = this.areObjectsEqual(this.dotstatusCreateForm.value, this.dotstatusOldCreateForm.value);
         // if(!isEqual){
         //   this.showButton = true;
         // }else{
         //   this.showButton = false;
         // }

     });
     
    });
  }
  areObjectsEqual(a: any, b: any): boolean {
    const aString = JSON.stringify(a);
    const bString = JSON.stringify(b);
  
    return aString === bString;
  }
  findChangedKeyValues(objA: any, objB: any): any {
    const resultA: any = {};
    const resultB: any = {};
  
    for (const key in objA) {
      if(key != 'id'){
        if (objA.hasOwnProperty(key) && objB.hasOwnProperty(key)) {
          if (JSON.stringify(objA[key]) !== JSON.stringify(objB[key])) {          
            resultA[key] = objA[key];
            resultB[key] = objB[key];          
          }
        } else {
          
            resultA[key] = objA[key];
          
        }
      }
    }
  
    for (const key in objB) {
      if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
        resultB[key] = objB[key];
      }
    }
  
    return {
      "oldData": resultA,
      "newData": resultB
    };
  }
  closeModal(sendData) {
    this.activeModal.close(sendData);
  }
  onSubmit(){
    this.submitted = true;
    if(this.prequityshares == true){
      if (this.dotstatusCreateForm.get('checkboxgroup.equityshares')?.value == '') {
        this.checkValidation = 'Enter the Equity Shares';
      // this.checkValidation?.push({'equityshares':'Enter the Equity Shares'});
        return false;
      }
    }else{
      this.dotstatusCreateForm.get('checkboxgroup.equityshares')?.clearValidators();
      this.dotstatusCreateForm.get('checkboxgroup.equityshares')?.updateValueAndValidity();
    }

     if(this.prpreferenceshares == true){
      if (this.dotstatusCreateForm.get('checkboxgroup.preferenceshares')?.value == '') {
        this.checkValidation ='Please Enter the Preference Shares';

        return false;
      }
    }else{
      this.dotstatusCreateForm.get('checkboxgroup.preferenceshares')?.clearValidators();
      this.dotstatusCreateForm.get('checkboxgroup.preferenceshares')?.updateValueAndValidity();
    }
     if(this.prwarrantsshares == true){
      if (this.dotstatusCreateForm.get('checkboxgroup.warrantsshares')?.value == '') {
      //this.checkValidation.push({'warrantsshares':'Please Enter the Warrants Shares'});
        this.checkValidation ='Please Enter the Warrants Shares';
        return false;
      }
    }else{
      this.dotstatusCreateForm.get('checkboxgroup.warrantsshares')?.clearValidators();
      this.dotstatusCreateForm.get('checkboxgroup.warrantsshares')?.updateValueAndValidity();
    }
     if(this.prconvertibledebenturesshares == true){
      if (this.dotstatusCreateForm.get('checkboxgroup.convertibledebenturesshares')?.value == '') {
        this.checkValidation = 'Please Enter the Convertible Debenturesshares';
        return false;
      }
    }else{
      this.dotstatusCreateForm.get('checkboxgroup.convertibledebenturesshares')?.clearValidators();
      this.dotstatusCreateForm.get('checkboxgroup.convertibledebenturesshares')?.updateValueAndValidity();

    }
     if(this.prnonconvertibledebentureshares == true){
      if (this.dotstatusCreateForm.get('checkboxgroup.nonconvertibledebenturesshares')?.value == '') {
        this.checkValidation.push({'nonconvertibledebenturesshares':'Enter the Non Convertible Debenturesshares'});
        this.checkValidation = 'Please Enter the Convertible Debenturesshares';
        return false;
      }
    }else{
      this.dotstatusCreateForm.get('checkboxgroup.nonconvertibledebenturesshares')?.clearValidators();
      this.dotstatusCreateForm.get('checkboxgroup.nonconvertibledebenturesshares')?.updateValueAndValidity();
    }
     if(this.prrightsentitlementsshares == true){
      if (this.dotstatusCreateForm.get('checkboxgroup.rightsentitlementsshares')?.value == '') {
        //this.checkValidation.push({'rightsentitlementsshares':'Enter th Rights Entitlements'});
        this.checkValidation = 'Please Enter the Rights Entitlements';

        return false;
      }
    }else{
      this.dotstatusCreateForm.get('checkboxgroup.rightsentitlementsshares')?.clearValidators();
      this.dotstatusCreateForm.get('checkboxgroup.rightsentitlementsshares')?.updateValueAndValidity();
    }
     if(this.prothersshares == true){
      if (this.dotstatusCreateForm.get('checkboxgroup.othersshares')?.value == '') {
       // this.checkValidation.push({'othersshares': 'Enter th Others Shares'});
       this.checkValidation = 'Please Enter the Others Shares';

        return false;
      }
    }else{
      this.dotstatusCreateForm.get('checkboxgroup.othersshares')?.clearValidators();
      this.dotstatusCreateForm.get('checkboxgroup.othersshares')?.updateValueAndValidity();
    }

 
  const changedKeyValues = this.findChangedKeyValues(this.dotstatusOldCreateForm.value,this.dotstatusCreateForm.value);
        
      let reqObj = {
        data:changedKeyValues,
        id:this.dotstatusCreateForm.value.id,
      }
    const checkboxGroupControls = this.dotstatusCreateForm.get('checkboxgroup')['controls'];
    const emptyFields = Object.keys(checkboxGroupControls).filter(key => 
      checkboxGroupControls[key].errors !== null
    );

    if(this.dotstatusCreateForm.status !== 'INVALID'){
      this.isLoading = true;
      this.button = 'Processing';
      this.dotstatusCreateForm.value.dpid = this.listDpDetails.id;
      this.dotstatusCreateForm.value.dpName = this.listDpDetails.dpName;
      this.dotstatusCreateForm.value.dpemail = this.listDpDetails.email;
      this.dotstatusCreateForm.value.dpdesignation = this.listDpDetails.dpDesignation;
      this.dotstatusCreateForm.value.tradingcompanyname = this.companyName;
      this.dotstatusCreateForm.value.OldcheckboxgroupArr = this.dotstatusOldCreateForm.get('checkboxgroup')?.value;
      this.dpService.annualnddeclarationstatusupdate(this.dotstatusCreateForm.value).subscribe(data =>{  
        
        if (data?.success == '1') {
          this.isLoading = false;
           this.button = 'Update';
           this.toastr.success("Declaration of Trade Successfully Updated");
           this.activeModal.close(true);

        }
      })


    }else if(emptyFields.length > 1){
      this.toastr.warning("Please fill all Mandatory fields.");
      return false;
    } 
  }

}
